export enum EnableStatus {
  ENABLED = '有効',
  DISABLED = '無効',
}
